
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
  inject
} from '@angular/core';
import { DialogComponent } from '../../../../shared/components/dialog/dialog.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { SharedService } from '../../../../shared/services/shared.service';
import { environment } from '../../../../../environments/environment';

type dialogTypes = 'simple' | 'maximizable' | 'draggable' | 'all';

@Component({
  selector: 'app-about-modal-component',
  standalone: true,
  imports: [DialogComponent, ButtonComponent],
  templateUrl: './about-modal.component.html',
  styleUrl: './about-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutModalComponent implements OnInit {
  @Input() isDialogVisible: boolean = false; // Controls dialog visibility
  @Output() onHide = new EventEmitter<void>(); // Emits when modal closes

  public dialogType: dialogTypes = 'simple';
  public basicInfoFields: { label: string; value: any }[] = [];
  public vehicleFields: { label: string; value: any }[] = [];
  currentYear = signal<number>(0);
  version = signal<string>('');
  projectName = environment.projectName;

  private readonly sharedService = inject(SharedService)

  ngOnInit() {
    const currentDate = new Date();
    this.currentYear.set(currentDate.getFullYear());
    this.loadVersion();
  }

  private loadVersion(): void {
    this.sharedService.getVersion(this.projectName).subscribe({
      next: (res: string) => {
        if (res) {
          this.version.set(res);
        }
      },
      error: () => {},
    });
  }

  public handleDialogClose(): void {
    this.isDialogVisible = false; // Hide the modal
    this.onHide.emit(); // Notify parent about the closure
  }
}
